import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import { getTextedDate, getFormattedDateTime } from '../_helpers/dates'
import CertificateView from './CertificateView'

const AdminUiView = (props) => {
  const { config_params, adminUiCertificateJobs } = props
  const theme = useTheme()

  const [certificates, setCertificates] = useState([])

  const keySmStyle = {
    color: theme.palette.vodka,
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '10px',
  }

  const keyLgStyle = {
    color: theme.palette.grayX11,
    fontSize: '18px',
    fontWeight: '500',
    marginBottom: '10px',
  }

  const valueSmStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '20px',
  }

  const valueMdStyle = {
    color: theme.palette.greenSheen,
    fontSize: '16px',
    fontWeight: '500',
  }

  const noLogoStyle = {
    width: '200px',
    height: '80px',
    borderRadius: '10px',
    border: `${theme.palette.lightSilver} 1px dashed`,
    color: theme.palette.lightSilver,
    fontSize: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
  }

  const pickColorStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '30px',
  }

  useEffect(() => {
    const getDomainsByJobId = (job_id) => {
      let result = []
      const filtered_jobs = adminUiCertificateJobs.filter(item => item.job_id === job_id)

      filtered_jobs.forEach(item => {
        result.push(item.domain)
      })

      return result
    }

    let _certificates = []
    let job_ids = []

    adminUiCertificateJobs.forEach(c => {
      const domains = getDomainsByJobId(c.job_id)
      const expired = c.expiration_date && getFormattedDateTime(c.expiration_date) <= getFormattedDateTime()

      if (!job_ids.includes(c.job_id)) {
        _certificates.push({
          domains,
          is_valid: c.cert_type === 'generate' || !expired,
          type: c.cert_type,
          expiration_date: c.expiration_date ? getTextedDate(c.expiration_date) : '',
          expired,
        })

        job_ids.push(c.job_id)
      }      
    })

    setCertificates(_certificates)
  }, [adminUiCertificateJobs])
  
  return (
    <>
      {
        (config_params && Object.keys(config_params).length !== 0) ?
        <Grid container spacing={4}>

          <Grid
            size={{ xs: 12, lg: 6 }}
            sx={{ borderRight: `${theme.palette.lightSilver} 1px dotted` }}
          >

            <Box sx={keySmStyle}>{defaultTexts.userInterfaceDomain}:</Box>
            <Box sx={{ marginBottom: '20px' }}>
              {
                certificates.map((item, index) => (
                  <CertificateView key={index} {...item} />
                ))
              }
            </Box>

            <Box sx={keySmStyle}>{defaultTexts.googleRecaptchaConfiguration}:</Box>
            <Box sx={keyLgStyle}>{defaultTexts.siteKey}:</Box>
            <Box sx={valueSmStyle}>{ config_params.captcha_config ? config_params.captcha_config.site_key : '' }</Box>

            <Box sx={keyLgStyle}>{defaultTexts.secretKey}:</Box>
            <Box sx={valueSmStyle}>{ config_params.captcha_config ? config_params.captcha_config.secret_key : '' }</Box>

          </Grid>

          <Grid size={{ xs: 12, lg: 6 }}>
            
            <Box sx={keySmStyle}>{defaultTexts.customizeYourInterfaceAppearance}:</Box>

            <Stack
              direction='row'
              alignItems='center'
              justifyContent='flex-start'
              spacing={2}
              sx={{
                borderBottom: `${theme.palette.lightSilver} 1px dotted`,
                paddingBottom: '10px',
                marginBottom: '20px',
              }}
            >
              <Box>
                {
                  config_params.logo ?
                  <img src={constants.s3URL + constants.s3Bucket + config_params.logo} alt='' style={{ maxWidth: '200px' }} /> :
                  <Box sx={noLogoStyle}>{defaultTexts.noLogo}</Box>
                }
              </Box>
              <Box sx={valueMdStyle}>{defaultTexts.adminUiLogo}</Box>
            </Stack>

            <Stack
              direction='row'
              alignItems='center'
              justifyContent='flex-start'
              spacing={2}
              sx={{ marginBottom: '30px' }}
            >
              <Box sx={{ ...pickColorStyle, background: config_params.primary_color }}></Box>
              <Box sx={valueMdStyle}>{defaultTexts.primaryColor}</Box>
            </Stack>

            <Stack
              direction='row'
              alignItems='center'
              justifyContent='flex-start'
              spacing={2}
            >
              <Box sx={{ ...pickColorStyle, background: config_params.secondary_color }}></Box>
              <Box sx={valueMdStyle}>{defaultTexts.secondaryColor}</Box>
            </Stack>

          </Grid>

        </Grid> :
        <Box
          sx={{
            padding: '20px',
            fontSize: '20px',
          }}
        >
          {defaultTexts.notConfigured}
        </Box>
      }
    </>
  )
}

export default AdminUiView